import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert, Home, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui';

export default function AccessDenied() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 p-4 text-center">
      <div className="relative mb-6">
        <div className="absolute -inset-1 rounded-full bg-rose-100 blur-sm animate-pulse" />
        <div className="relative flex h-24 w-24 items-center justify-center rounded-full bg-white shadow-xl ring-4 ring-rose-50">
          <ShieldAlert className="h-12 w-12 text-rose-500" />
        </div>
      </div>

      <h1 className="mb-2 text-2xl font-bold text-slate-900">Dừng lại! Truy cập bị từ chối</h1>
      <p className="mb-8 max-w-md text-slate-500 sm:text-sm text-xs">
        Bạn không có quyền truy cập vào khu vực này. Vui lòng liên hệ Quản trị viên nếu bạn tin rằng đây là một sự nhầm lẫn.
      </p>

      <div className="flex flex-col gap-3 sm:flex-row">
        <Button
          variant="outline"
          className="flex items-center gap-2"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft className="h-4 w-4" />
          Quay lại
        </Button>
        <Button
          className="flex items-center gap-2 bg-brand-600 hover:bg-brand-700"
          onClick={() => navigate('/')}
        >
          <Home className="h-4 w-4" />
          Trang chủ
        </Button>
      </div>

      <div className="mt-12 text-[10px] uppercase tracking-widest text-slate-400">
        Landscape Security Protocol Layer 3
      </div>
    </div>
  );
}
